import { FieldHelpTextList } from "@/components/fields/help-texts/FieldHelpTextList";

const FieldHelpTexts = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Field Help Text Management</h1>
        <p className="text-muted-foreground">
          Customize help texts shown to users when they need to provide additional information.
        </p>
      </div>
      <FieldHelpTextList />
    </div>
  );
};

export default FieldHelpTexts;
